import { createFileRoute } from '@tanstack/react-router';

import { SupplierContactsPage } from '@/areas/suppliers/Suppliers/SupplierContactsPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/suppliers/_sidebar/supplier-contacts/')({
    staticData: { access: { permissions: ['view:supplier'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SupplierContactsPage />;
}
